export enum ProviderCommissionEnum {
  fixed = 21,
  percent = 22,
}
